
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import { useId, useMemo } from "react";
import styles from "../style.module.css";

export default function BrandSlider({ brands = [], top = 10, left = 0, reverse = false }) {
    const uid = useId().replace(/:/g, "");
    const swiperClass = `about-brands-swiper-${uid}`;

    const duplicatedBrands = useMemo(() => {
        if (!brands || brands.length === 0) return [];
        if (brands.length < 10) {
            return [...brands, ...brands, ...brands, ...brands];
        }
        return [...brands, ...brands, ...brands];
    }, [brands]);

    if (!brands || brands.length === 0) {
        return <div style={{ height: "58px", marginTop: `${top}px` }} />;
    }

    return (
        <div className={styles.brand_slider_wrap} style={{ marginTop: `${top}px` }}>
            <style>{`
                .${swiperClass} .swiper-wrapper {
                    transition-timing-function: linear !important;
                }
                .${swiperClass} .swiper-slide {
                    width: auto !important;
                    height: auto;
                    display: flex;
                    align-items: center;
                }
            `}</style>
            <Swiper
                className={`${swiperClass} ${styles.brand_swiper}`}
                modules={[Autoplay, FreeMode]}
                spaceBetween={10}
                slidesPerView="auto"
                loop={true}
                loopAdditionalSlides={duplicatedBrands.length}
                speed={5000}
                style={{
                    marginLeft: `-${left}px`,
                }}
                allowTouchMove={false}
                freeMode={{
                    enabled: true,
                    momentum: false,
                }}
                autoplay={{
                    delay: 0,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false,
                    reverseDirection: reverse,
                }}
                observer={true}
                observeParents={true}
            >
                {duplicatedBrands.map((brand, index) => (
                    <SwiperSlide key={`${brand.id || brand.name || "brand"}-${index}`}>
                        <div className={styles.brand_pill}>
                            <img
                                src={process.env.REACT_APP_STORAGE_URL + brand.logo}
                                alt={brand.name || "brand"}
                                className={styles.brand_pill_logo}
                            />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
